"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFiscalPeriodsForRevenues = exports.getFiscalPeriodsForQres = exports.determineTaxYearEndDate = exports.determineTaxYearStartDate = void 0;
const array_utils_1 = require("./array.utils");
const date_utils_1 = require("./date.utils");
const month_year_utils_1 = require("./month-year.utils");
const determineTaxYearStartDate = ({ periodDates, shortYearPeriod, year, }) => {
    if (!shortYearPeriod && periodDates) {
        return year + periodDates.firstDayOfPeriod.slice(4);
    }
    if (!shortYearPeriod) {
        throw new Error('Either shortYearPeriod or periodDates must be provided to determine tax year start date');
    }
    const isStandardToFiscalYearConversion = shortYearPeriod.startMonthYear.month === 0;
    return isStandardToFiscalYearConversion
        ? getStandardYearToFiscalYearConversionStartDate(year, shortYearPeriod)
        : getFiscalYearToStandardYearConversionStartDate(year, shortYearPeriod);
};
exports.determineTaxYearStartDate = determineTaxYearStartDate;
const getFiscalYearToStandardYearConversionStartDate = (year, shortYearPeriod) => {
    const { endMonthYear, startMonthYear } = shortYearPeriod;
    const shortYearStartYear = startMonthYear.year;
    const shortYearStartMonth = startMonthYear.month;
    const shortYearEndMonth = endMonthYear.month;
    const shortYearStartMonthYear = (0, month_year_utils_1.toMonthYearString)(startMonthYear);
    if (year === shortYearStartYear) {
        return `${shortYearStartMonthYear}-01`;
    }
    else if (year > shortYearStartYear) {
        // If the year is greater than the short year, we use the previous year and add 1 month to the short year end month
        return (0, date_utils_1.addMonths)(new Date(year - 1, shortYearEndMonth, 1), 1);
    }
    else {
        // If the year is before the short year, we use the tax year and the short year start month
        return `${year}-${(shortYearStartMonth + 1).toString().padStart(2, '0')}-01`;
    }
};
const getStandardYearToFiscalYearConversionStartDate = (year, shortYearPeriod) => {
    const { endMonthYear, startMonthYear } = shortYearPeriod;
    const shortYearStartYear = startMonthYear.year;
    const shortYearStartMonth = startMonthYear.month;
    const shortYearEndMonth = endMonthYear.month;
    const shortYearStartMonthYear = (0, month_year_utils_1.toMonthYearString)(startMonthYear);
    if (year === shortYearStartYear) {
        return `${shortYearStartMonthYear}-01`;
    }
    else if (year > shortYearStartYear) {
        // If the year is more than 1 year after the short year, we use the tax year and add 1 month to the short year end month
        return (0, date_utils_1.addMonths)(new Date(year, shortYearEndMonth, 1), 1);
    }
    else {
        // If the year is before the short year, we use the tax year and the short year start month
        return `${year}-${(shortYearStartMonth + 1).toString().padStart(2, '0')}-01`;
    }
};
const determineTaxYearEndDate = ({ periodDates, shortYearPeriod, year, }) => {
    if (!shortYearPeriod && periodDates) {
        const periodStartingYear = periodDates.firstDayOfPeriod.slice(0, 4);
        const periodEndingYear = periodDates.lastDayOfPeriod.slice(0, 4);
        const sameYear = periodStartingYear === periodEndingYear;
        return (sameYear ? year : year + 1) + periodDates.lastDayOfPeriod.slice(4);
    }
    if (!shortYearPeriod) {
        throw new Error('Either shortYearPeriod or periodDates must be provided to determine tax year end date');
    }
    const isStandardToFiscalYearConversion = shortYearPeriod.startMonthYear.month === 0;
    return isStandardToFiscalYearConversion
        ? getStandardYearToFiscalYearConversionEndDate(year, shortYearPeriod)
        : getFiscalYearToStandardYearConversionEndDate(year, shortYearPeriod);
};
exports.determineTaxYearEndDate = determineTaxYearEndDate;
const getFiscalYearToStandardYearConversionEndDate = (year, shortYearPeriod) => {
    const { endMonthYear, startMonthYear } = shortYearPeriod;
    const shortYearStartYear = startMonthYear.year;
    const shortYearStartMonth = startMonthYear.month;
    const shortYearEndMonth = endMonthYear.month;
    const shortYearEndYear = endMonthYear.year;
    if (year === shortYearStartYear) {
        return (0, month_year_utils_1.getLastDateStringOfMonthYear)(endMonthYear);
    }
    else if (year > shortYearEndYear && shortYearEndMonth === 11) {
        return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year, shortYearEndMonth, 1))
            .toISOString()
            .slice(0, 10);
    }
    else if (year > shortYearStartYear && shortYearEndMonth != 11) {
        return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year + 1, shortYearEndMonth, 1))
            .toISOString()
            .slice(0, 10);
    }
    else {
        const taxYearEndDate = new Date(year + 1, shortYearStartMonth, 1);
        taxYearEndDate.setDate(taxYearEndDate.getDate() - 1);
        return taxYearEndDate.toISOString().slice(0, 10);
    }
};
const getStandardYearToFiscalYearConversionEndDate = (year, shortYearPeriod) => {
    const { endMonthYear, startMonthYear } = shortYearPeriod;
    const shortYearStartYear = startMonthYear.year;
    const shortYearStartMonth = startMonthYear.month;
    const shortYearEndMonth = endMonthYear.month;
    const shortYearEndYear = endMonthYear.year;
    if (year === shortYearStartYear) {
        return (0, month_year_utils_1.getLastDateStringOfMonthYear)(endMonthYear);
    }
    else if (year > shortYearEndYear && shortYearEndMonth === 11) {
        return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year, shortYearEndMonth, 1))
            .toISOString()
            .slice(0, 10);
    }
    else if (year > shortYearStartYear && shortYearEndMonth != 11) {
        return (0, date_utils_1.getLastDayOfTheMonth)(new Date(year + 1, shortYearEndMonth, 1))
            .toISOString()
            .slice(0, 10);
    }
    else if (year < shortYearStartYear && shortYearStartMonth === 0) {
        const taxYearEndDate = new Date(year + 1, shortYearStartMonth, 1);
        taxYearEndDate.setDate(taxYearEndDate.getDate() - 1);
        return taxYearEndDate.toISOString().slice(0, 10);
    }
    else {
        const taxYearEndDate = new Date(year, shortYearStartMonth, 1);
        taxYearEndDate.setDate(taxYearEndDate.getDate() - 1);
        return taxYearEndDate.toISOString().slice(0, 10);
    }
};
/**
 * Get the prior fiscal periods for QREs.
 * @param firstYear - The first year of the range of years to get the tax year and period for.
 * @param shortYearPeriod - The short tax year period to use for the tax year and period.
 * @param periodDates - The period dates to use when there is no shortYearPeriod. This is most likely the tax filing start and end dates.
 * @returns The tax year and period for the given years.
 */
const getFiscalPeriodsForQres = ({ firstYear, periodDates, shortYearPeriod, }) => {
    const currentTaxYear = (0, date_utils_1.getCurrentTaxYear)(periodDates.lastDayOfPeriod);
    const years = getYearsForQres({ firstYear, shortYearPeriod, currentTaxYear });
    const includeYearAfterShortYear = currentTaxYear !== shortYearPeriod?.startMonthYear.year;
    return getFiscalPeriodsBasedOnYears({ years, periodDates, shortYearPeriod, includeYearAfterShortYear });
};
exports.getFiscalPeriodsForQres = getFiscalPeriodsForQres;
/**
 * Get the prior fiscal periods for Revenues.
 * @param firstYear - The first year of the range of years to get the tax year and period for.
 * @param shortYearPeriod - The short tax year period to use for the tax year and period.
 * @param periodDates - The period dates to use when there is no shortYearPeriod. This is most likely the tax filing start and end dates.
 * @returns The tax year and period for the given years.
 */
const getFiscalPeriodsForRevenues = ({ firstYear, periodDates, shortYearPeriod, }) => {
    const currentTaxYear = (0, date_utils_1.getCurrentTaxYear)(periodDates.lastDayOfPeriod);
    const years = getYearsForRevenues({ firstYear, currentTaxYear });
    // Include year after short year is always true for revenues as we use it to get the current tax year revenue data
    return getFiscalPeriodsBasedOnYears({ years, periodDates, shortYearPeriod, includeYearAfterShortYear: true });
};
exports.getFiscalPeriodsForRevenues = getFiscalPeriodsForRevenues;
const getFiscalPeriodsBasedOnYears = ({ includeYearAfterShortYear = false, periodDates, shortYearPeriod, years, }) => {
    if (!years.length) {
        return [];
    }
    // Handle case when no shortYearPeriod is provided
    if (!shortYearPeriod) {
        if (!periodDates) {
            throw new Error('Either shortYearPeriod or periodDates must be provided');
        }
        return years.map((year) => ({
            firstDayOfPeriod: (0, exports.determineTaxYearStartDate)({ year, periodDates }),
            lastDayOfPeriod: (0, exports.determineTaxYearEndDate)({ year, periodDates }),
        }));
    }
    const sortedYears = years.sort((a, b) => b - a);
    const periods = [];
    const shortYearStartYear = shortYearPeriod.startMonthYear.year;
    // Add periods for years less than or equal to short year
    sortedYears
        .filter((year) => year <= shortYearStartYear)
        .forEach((year) => {
        periods.push({
            firstDayOfPeriod: (0, exports.determineTaxYearStartDate)({ year, shortYearPeriod }),
            lastDayOfPeriod: (0, exports.determineTaxYearEndDate)({ year, shortYearPeriod }),
        });
    });
    // Adds period after short year- special case because it has the same tax year as short year
    const shortYearEndDate = new Date(shortYearPeriod.endMonthYear.year, shortYearPeriod.endMonthYear.month, 1);
    const firstDayOfTaxPeriodAfterShortYear = (0, date_utils_1.addMonths)(shortYearEndDate, 1);
    const shortYearEndDatePlusOneYear = new Date(shortYearPeriod.endMonthYear.year + 1, shortYearPeriod.endMonthYear.month, 1);
    const lastDayOfTaxPeriodAfterShortYear = (0, date_utils_1.getLastDayOfTheMonth)(shortYearEndDatePlusOneYear).toISOString().slice(0, 10);
    if (years.includes(shortYearPeriod.startMonthYear.year) && includeYearAfterShortYear) {
        // Pushes period after short year
        periods.push({
            firstDayOfPeriod: firstDayOfTaxPeriodAfterShortYear,
            lastDayOfPeriod: lastDayOfTaxPeriodAfterShortYear,
        });
    }
    // Add periods for years after short year
    sortedYears
        .filter((year) => year > shortYearStartYear)
        .forEach((year) => {
        periods.push({
            firstDayOfPeriod: (0, exports.determineTaxYearStartDate)({ year, shortYearPeriod }),
            lastDayOfPeriod: (0, exports.determineTaxYearEndDate)({ year, shortYearPeriod }),
        });
    });
    return periods.sort((a, b) => {
        const dateA = new Date(a.firstDayOfPeriod);
        const dateB = new Date(b.firstDayOfPeriod);
        return dateB.getTime() - dateA.getTime();
    });
};
const getYearsForQres = ({ currentTaxYear, firstYear, shortYearPeriod, }) => {
    const isShortYearThisYear = shortYearPeriod?.startMonthYear.year === currentTaxYear;
    const mostRecentClosedTaxYear = isShortYearThisYear ? currentTaxYear : currentTaxYear - 1;
    const upperBoundForQreYears = firstYear ? Math.min(mostRecentClosedTaxYear, firstYear + 9) : mostRecentClosedTaxYear;
    const lowerBoundForQreYears = firstYear ? firstYear - 1 : currentTaxYear - 4;
    return (0, array_utils_1.range)(upperBoundForQreYears, lowerBoundForQreYears, -1);
};
const getYearsForRevenues = ({ currentTaxYear, firstYear, }) => {
    const upperBoundForRevenueYears = firstYear ? Math.min(currentTaxYear, firstYear + 9) : currentTaxYear;
    const lowerBoundForRevenueYears = firstYear ? firstYear - 1 : currentTaxYear - 5;
    return (0, array_utils_1.range)(upperBoundForRevenueYears, lowerBoundForRevenueYears, -1);
};
